module.exports = __webpack_public_path__ + "img/geografia-nsk.9f0d99bd.jpg";